import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import DefaultLayout from '../../layout/DefaultLayout';

import UserTable from './UserTable';

const AllUsers = () => {

  return (
    <DefaultLayout>
      <BreadcrumbTwo/>
      <UserTable />
    </DefaultLayout>
  );
};

export default AllUsers;
